<template>
    <svg
        :width="width"
        :height="height"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="color"
    >
        <mask
            id="mask0_devices"
            style="mask-type: alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="16"
            height="16"
        >
            <rect width="16" height="16" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_devices)">
            <path
                d="M1.33203 13.3346V12.0013H7.9987V13.3346H1.33203ZM3.33203 11.3346C2.96536 11.3346 2.65148 11.2041 2.39036 10.943C2.12925 10.6819 1.9987 10.368 1.9987 10.0013V4.0013C1.9987 3.63464 2.12925 3.32075 2.39036 3.05964C2.65148 2.79852 2.96536 2.66797 3.33203 2.66797H12.6654C13.032 2.66797 13.3459 2.79852 13.607 3.05964C13.8681 3.32075 13.9987 3.63464 13.9987 4.0013H3.33203V10.0013H7.9987V11.3346H3.33203ZM13.332 12.0013V6.66797H10.6654V12.0013H13.332ZM10.332 13.3346C10.0543 13.3346 9.81814 13.2374 9.6237 13.043C9.42925 12.8485 9.33203 12.6124 9.33203 12.3346V6.33464C9.33203 6.05686 9.42925 5.82075 9.6237 5.6263C9.81814 5.43186 10.0543 5.33464 10.332 5.33464H13.6654C13.9431 5.33464 14.1793 5.43186 14.3737 5.6263C14.5681 5.82075 14.6654 6.05686 14.6654 6.33464V12.3346C14.6654 12.6124 14.5681 12.8485 14.3737 13.043C14.1793 13.2374 13.9431 13.3346 13.6654 13.3346H10.332ZM11.9987 8.33464C12.1431 8.33464 12.2626 8.28464 12.357 8.18464C12.4515 8.08464 12.4987 7.96797 12.4987 7.83464C12.4987 7.69019 12.4515 7.57075 12.357 7.4763C12.2626 7.38186 12.1431 7.33464 11.9987 7.33464C11.8654 7.33464 11.7487 7.38186 11.6487 7.4763C11.5487 7.57075 11.4987 7.69019 11.4987 7.83464C11.4987 7.96797 11.5487 8.08464 11.6487 8.18464C11.7487 8.28464 11.8654 8.33464 11.9987 8.33464Z"
                fill="currentColor"
            />
        </g>
    </svg>
</template>

<script>
export default {
    name: 'devices-icon',
    props: {
        width: {
            type: [String, Number],
            default: 16,
        },
        height: {
            type: [String, Number],
            default: 16,
        },
        color: {
            type: String,
            default: 'text-accent-violet-3',
        },
    },
};
</script>

